<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openUploadFormDialog="() => (uploadFormDialogVisible = true)"
      @openEditFromDialog="openEditFromDialog"
      @reload="getData()"
    >
    </Main>

    <UploadFormDialog
      :title="$l('dialog_tech_doc_upload') || '上传工艺说明文档'"
      :visible.sync="uploadFormDialogVisible"
      :changeOrderCode="changeOrderCode"
      @reload="getData()"
    />

    <EditFromDialog
      :title="$l('dialog_tech_doc_edit') || '编辑工艺说明文档'"
      :visible.sync="editFromDialogOption.visible"
      :changeOrderTechDocCode="editFromDialogOption.changeOrderTechDocCode"
      :orderTechDocCode="editFromDialogOption.orderTechDocCode"
      :changeOrderCode="changeOrderCode"
      @reload="getData()"
    />
  </div>
</template>
<script>
import Main from './main'
import EditLoading from '@/mixins/edit-loading'
import UploadFormDialog from '../upload-form/dialog.vue'
import EditFromDialog from '../edit-form/dialog.vue'
export default {
  mixins: [EditLoading],
  components: { Main, UploadFormDialog, EditFromDialog },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      uploadFormDialogVisible: false,
      editFromDialogOption: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.changeOrderCode) return
      this.loading = true
      this.$api
        .changeOrderTechDocListApi({ changeOrderCode: this.changeOrderCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFromDialog(code) {
      console.log(code)
      this.editFromDialogOption = {
        visible: true,
        orderTechDocCode: code.orderTechDocCode,
        changeOrderTechDocCode: code.changeOrderTechDocCode,
      }
    },
  },
}
</script>
